import { WebHaptics } from 'web-haptics';

// Singleton: debug audio = the click sounds from https://haptics.lochie.me
// showSwitch stays off — no demo UI / emoji chrome
let instance = null;

function getHaptics() {
  if (!instance) {
    instance = new WebHaptics({ debug: true, showSwitch: false });
  }
  return instance;
}

export function playHaptic(preset) {
  try {
    getHaptics().trigger(preset);
  } catch (_) {
    // AudioContext may be blocked until a user gesture — ignore
  }
}

export function destroyHaptics() {
  if (instance) {
    instance.destroy();
    instance = null;
  }
}
